import React from "react";
import { Table, Button, Form, Alert, Stack } from "react-bootstrap";
import { Trash2, Edit2, Save, X, AlertCircle } from "lucide-react";
import { CSVStudent } from "../../../../hooks/CSV/students/useCSVStudentData";

type InvalidDataTableProps = {
  data: CSVStudent[];
  searchTerm: string;
  editingIndex: number | null;
  editingStudent: CSVStudent | null;
  handleEditInvalidItem: (index: number) => void;
  handleRemoveInvalidItem: (index: number) => void;
  handleChangeEditingStudent: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSaveEdit: () => void;
  handleCancelEdit: () => void;
};

export const InvalidDataTable: React.FC<InvalidDataTableProps> = ({
  data,
  searchTerm,
  editingIndex,
  editingStudent,
  handleEditInvalidItem,
  handleRemoveInvalidItem,
  handleChangeEditingStudent,
  handleSaveEdit,
  handleCancelEdit,
}) => {
  const filteredData = data.filter(
    (student) =>
      student.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      student.email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (filteredData.length === 0) {
    return null;
  }

  return (
    <div className="mt-4">
      {/* Removendo completamente o fundo e borda do Alert */}
      <Alert
        style={{
          backgroundColor: "transparent",
          border: "none",
          paddingLeft: 0,
        }}
        className="mb-3"
      >
        <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between">
          <div className="d-flex align-items-center mb-2 mb-md-0">
            <AlertCircle size={20} className="me-2 text-danger" />
            <div>
              <h6 className="alert-heading mb-0 fw-semibold text-danger">
                Dados Inválidos Detectados
              </h6>
              <p className="mb-0 small text-danger">
                Os registros abaixo não serão importados devido a erros
              </p>
            </div>
          </div>
          <span className="badge text-danger px-2 py-1 rounded-pill">
            {filteredData.length} registro{filteredData.length !== 1 ? "s" : ""}
          </span>
        </div>
      </Alert>

      <div
        className="table-responsive border rounded bg-white"
        style={{ maxHeight: "400px", overflowY: "auto" }}
      >
        <Table hover className="mb-0 align-middle text-center">
          <thead className="bg-light">
            <tr>
              <th className="px-3 py-3 border-bottom text-muted">Nome</th>
              <th className="px-3 py-3 border-bottom text-muted">E-mail</th>
              <th className="px-3 py-3 border-bottom text-muted">Erro</th>
              <th
                className="px-3 py-3 border-bottom text-center text-muted"
                style={{ width: "120px" }}
              >
                Ações
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((item, index) => (
              <tr
                key={index}
                className={index % 2 === 0 ? "bg-light bg-opacity-50" : ""}
              >
                {editingIndex === index ? (
                  <>
                    <td className="px-3 py-2 align-middle">
                      <Form.Control
                        type="text"
                        name="name"
                        value={editingStudent?.name || ""}
                        onChange={handleChangeEditingStudent}
                        className="form-control form-control-sm border-primary"
                        placeholder="Nome do aluno"
                      />
                    </td>
                    <td className="px-3 py-2 align-middle">
                      <Form.Control
                        type="email"
                        name="email"
                        value={editingStudent?.email || ""}
                        onChange={handleChangeEditingStudent}
                        className="form-control form-control-sm border-primary"
                        placeholder="email@exemplo.com"
                      />
                    </td>
                    <td className="px-3 py-2 align-middle text-center">
                      <span className="text-danger small d-flex align-items-center justify-content-center">
                        <AlertCircle size={14} className="me-1" />
                        {editingStudent?.error}
                      </span>
                    </td>
                    <td className="px-3 py-2 text-center align-middle">
                      <Stack
                        direction="horizontal"
                        gap={2}
                        className="justify-content-center"
                      >
                        <Button
                          variant="outline-success"
                          size="sm"
                          className="d-flex align-items-center"
                          onClick={handleSaveEdit}
                          title="Salvar alterações"
                        >
                          <Save size={14} className="me-1" />
                          Salvar
                        </Button>
                        <Button
                          variant="outline-secondary"
                          size="sm"
                          onClick={handleCancelEdit}
                          title="Cancelar edição"
                        >
                          <X size={14} />
                        </Button>
                      </Stack>
                    </td>
                  </>
                ) : (
                  <>
                    <td className="px-3 py-2 align-middle">
                      <span className="fw-medium">{item.name}</span>
                    </td>
                    <td className="px-3 py-2 align-middle">
                      <span className="text-muted small">{item.email}</span>
                    </td>
                    <td className="px-3 py-2 align-middle text-center">
                      <span className="text-danger small d-flex align-items-center justify-content-center">
                        <AlertCircle size={14} className="me-1 flex-shrink-0" />
                        {item.error}
                      </span>
                    </td>
                    <td className="px-3 py-2 text-center align-middle">
                      <Stack
                        direction="horizontal"
                        gap={1}
                        className="justify-content-center"
                      >
                        <Button
                          variant="link"
                          className="text-primary p-1"
                          onClick={() => handleEditInvalidItem(index)}
                          title="Editar registro"
                        >
                          <Edit2 size={16} />
                        </Button>
                        <Button
                          variant="link"
                          className="text-danger p-1"
                          onClick={() => handleRemoveInvalidItem(index)}
                          title="Remover registro"
                        >
                          <Trash2 size={16} />
                        </Button>
                      </Stack>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default InvalidDataTable;
